module.exports = __webpack_public_path__ + "onboarding-feed-teamcity.9afc081edb71c0e5b7e0c8d85bc024f0.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/library/empty/onboarding-feed-teamcity.svg
// module id = 590718156273976
// module chunks = 1